// @ts-nocheck

import React from 'react'
import styled from 'styled-components'
// import png from './plus.png'

export type NamesListTypes = {
    className?: string,
    title?: string,
    categoryName?: string,
    options?: Array<{ label: string, id: string }>,
    optionOnClickHandler?: any,
    addOptionHandler?: any,
    selected: string,
    hideIcon?: boolean
}

function NamesList(props: NamesListTypes) {

    return (
        <StyledNamesList className={props.className}>
            <div className='title'>{props.title}</div>
            <div className='list'>
                <div className='category-name'>{props.categoryName}</div>
                {props.options?.map(option => (
                    <StyledOption
                        title={option.label}
                        selected={props.selected == option.id}
                        onClick={() => props.optionOnClickHandler(option)}
                        id={option.id}>
                        <div className='text'>
                            {option.label}
                        </div>
                    </StyledOption>
                ))}
            </div>
            <div className='footer'>
                {!props.hideIcon &&   <img onClick={props.addOptionHandler} className='add' src={'/dashboard/analytic/plus.png'} alt='plus' />}
            </div>
        </StyledNamesList>
    )
}

NamesList.defaultProps = {
    title: 'Список докторов',
    categoryName: '',
    options: [
        { label: 'Иванов Иван Иванович', id: '1' },
        { label: 'Петров Петр Петрович', id: '2' },
        { label: 'Семенов Семен Семенович', id: '3' },
        { label: 'Васильев Василий Васильевич', id: '4' }
    ],
    optionOnClickHandler: () => {
    },
    addOptionHandler: () => {
    },
    selected: '2'


}


export default NamesList

const StyledNamesList = styled.div`
  border-radius: 15px;
  box-sizing: border-box;
  width: 325px;
  background: white;
  filter: drop-shadow(0px 3px 6px rgba(39, 45, 59, 0.2));
  font-family: 'Open Sans';
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 28px 36px;


  .title {
    font-size: 26px;
    font-weight: bold;
  }

  .list {
    margin-top: 22px;
    max-width: 100%;

    .category-name {
      color: #FF007C;
      font-size: 18px;
      font-weight: 700;
      font-family: 'Montserrat', 'Open Sans';
      margin-bottom: 22px;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 20px;

    .add {
      cursor: pointer;
    }
  }
`
const StyledOption = styled.div`
  height: 30px;
  cursor: pointer;
  font-weight: ${(p: any) => p.selected ? 'bold' : '400'};
  position: relative;
  align-items: center;
  max-width: 100%;
  font-size: 18px;
  display: flex;

  .text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    min-width: unset;
    display: block;
    max-width: 100%;

  }

  &::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 100%;
    border-radius: 100px;
    background: #0659C1;
    left: -10px;
    display: ${p => p.selected ? 'block' : 'none'};

  }


`